import { render, staticRenderFns } from "./sliderBarDialogShell.vue?vue&type=template&id=31b1a804"
import script from "./sliderBarDialogShell.vue?vue&type=script&lang=js"
export * from "./sliderBarDialogShell.vue?vue&type=script&lang=js"
import style0 from "./sliderBarDialogShell.vue?vue&type=style&index=0&id=31b1a804&prod&lang=scss"
import style1 from "./sliderBarDialogShell.vue?vue&type=style&index=1&id=31b1a804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports